require('./prtv-interface-5.scss');

import DemandeActions from '../../../../actions/demande.actions';
import { STEPS } from '../../../../utils/routes.util';
import DateUtil from '../../../../utils/date.util';
import { OTHER_VALUE, NO_ANSWER } from '../../model';

export default class PrtvInterface5Component {
  constructor() {
    this.controller = PrtvInterface5Controller;
    this.template = require('./prtv-interface-5.html');
  }
}

// @ngInject
class PrtvInterface5Controller {

  constructor($scope, $ngRedux) {
    this.$ngRedux = $ngRedux;
    this.$scope = $scope;
    this.OTHER_VALUE = OTHER_VALUE;
    this.NO_ANSWER = NO_ANSWER;
    this.data = {};
  }

  $onInit() {
    // Demande de récupération de la demande avant connexion au state
    this.$ngRedux.dispatch(DemandeActions.loadDemande(STEPS.PRTV_INTERFACE_5));

    // Connexion au state récupérer les données modifiées
    const disconnect = this.$ngRedux.connect(
      state => {
        return {
          working: state.general.working,
          failure: state.demande.failure,
          fetching: state.demande.fetching,
          demande: state.demande.data,
          dataPrtv3: state.demande.data.prtvInterface3 ? state.demande.data.prtvInterface3.asMutable({deep: true}) : this.data,
          dataPrtv4: state.demande.data.prtvInterface4 ? state.demande.data.prtvInterface4.asMutable({deep: true}) : this.data,
          demandeEnquetePapier: state.demande.data.prtvInterface1 ? state.demande.data.prtvInterface1.demandeEnquetePapier :
            state.demande.data.demandeEnquete ? state.demande.data.demandeEnquete : false,
          typePersonne: state.demande.data.typePersonne ? state.demande.data.typePersonne : '',
          nom: state.demande.data.prtvInterface1 ? state.demande.data.prtvInterface1.nom :
            state.demande.data.suivieAuthent ? state.demande.data.suivieAuthent.nom : '',
          prenom: state.demande.data.prtvInterface1 ? state.demande.data.prtvInterface1.prenom :
            state.demande.data.suivieAuthent ? state.demande.data.suivieAuthent.prenom : '',
          adresseComplete: state.demande.data.accueilInterface2 ? state.demande.data.accueilInterface2.adresse.numero +
              ' ' + state.demande.data.accueilInterface2.adresse.voie + ' ' + state.demande.data.accueilInterface2.adresse.commune.codepostal + ' ' +
              state.demande.data.accueilInterface2.adresse.commune.nom : '',
          channels: state.demande.data.prtvInterface3 ?  state.demande.data.prtvInterface3.channels.station ?
            state.demande.data.prtvInterface3.channels.station
              .filter(channel=>channel.switchValue)
              .map(channel => channel.name)
              .join(', ') : this.NO_ANSWER : this.NO_ANSWER,
        };
      }
    )(this);
    // Déconnexion du state à la suppression du composant
    this.$scope.$on('$destroy', disconnect);
    this.disableNext = true;
  }

  onChangeFirstPertubationDate() {
    this.firstPerturbationDateIsvalid = DateUtil.validate(this.data.firstPerturbationDate);
  }

  handleAnswer(answer) {
    if (answer === '' || answer === null) {
      return this.NO_ANSWER;
    } else if (answer === true) {
      return 'Oui';
    } else if (answer === false) {
      return 'Non';
    } else {
      return answer;
    }
  }

  handleAnswerConstruction(answer) {
    if (!this.dataPrtv4.isConstructionKnowledge) {
      return this.NO_ANSWER;
    } else {
      return this.handleAnswer(answer);
    }
  }
  // Actions
  prevStep() {
    this.$ngRedux.dispatch(DemandeActions.updatePrtvInterface5(this.data, true));
  }
  nextStep() {
    //assign the data of previous pages to this one for saving next
    Object.assign(this.data, this.dataPrtv3, this.dataPrtv4);
    this.$ngRedux.dispatch(DemandeActions.updatePrtvInterface5(this.data));
  }
}



// WEBPACK FOOTER //
// ./src/modules/prtv/components/prtv-interface-5/prtv-interface-5.component.js